import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from './AuthContext';
import './Auth.css';

function Register() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    gender: '',
    password: '',
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[6-9]\d{9}$/;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!emailRegex.test(formData.email)) {
      setError('Invalid email address (সঠিক ইমেল দিন)');
      setLoading(false);
      return;
    }

    if (formData.phone && !phoneRegex.test(formData.phone)) {
      setError('Enter valid 10-digit Indian mobile number');
      setLoading(false);
      return;
    }

    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters');
      setLoading(false);
      return;
    }

    try {
      // Step 1: Register
      await axios.post('/auth/register', formData);

      // Step 2: Auto-login
      const loginRes = await axios.post('/auth/login', {
        email: formData.email,
        password: formData.password,
      });

      login(loginRes.data.user, loginRes.data.token);

      navigate('/chat');

    } catch (err) {
      setError(
        err.response?.data?.error ||
        'Registration failed. Try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Sign Up (নিবন্ধন)</h1>
        <p>Create your REACH account (আপনার REACH অ্যাকাউন্ট তৈরি করুন)</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>

          <input
            name="firstName"
            placeholder="First Name (নাম)"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            name="lastName"
            placeholder="Last Name (পদবি)"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email (ইমেল)"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            name="phone"
            placeholder="Phone (মোবাইল)"
            value={formData.phone}
            onChange={handleChange}
          />

          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender (লিঙ্গ নির্বাচন করুন)</option>
            <option value="male">Male (পুরুষ)</option>
            <option value="female">Female (মহিলা)</option>
            <option value="other">Other (অন্যান্য)</option>
          </select>

          <input
            type="password"
            name="password"
            placeholder="Password (পাসওয়ার্ড)"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? "Creating Account..." : "Register (নিবন্ধন)"}
          </button>
        </form>

        <p className="auth-footer">
          Already have an account?{' '}
          <Link to="/login">Login (লগইন)</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
